/**
 * Return whether code is running on next server or in end user client.
 */
export const isServerSide = (): boolean => typeof window === 'undefined';
